import { CloseIcon } from '@synergy/theme-next';
import { DialogTitle, DialogTitleProps, IconButton, styled } from '@mui/material';
import { ReactElement } from 'react';

import { usePoolModalContext } from '../pool-modal';

const StyledIconButton = styled(IconButton)(({ theme }) => ({
    position: 'absolute',
    right: theme.spacing(3),
    top: theme.spacing(1.5),
}));

export type PoolModalTitleProps = DialogTitleProps;

export const PoolModalTitle = (props: PoolModalTitleProps): ReactElement => {
    const { children, ...dialogTitleProps } = props;
    const { onClose } = usePoolModalContext();

    return (
        <DialogTitle {...dialogTitleProps}>
            {children}
            {onClose && (
                <StyledIconButton aria-label="close" onClick={onClose}>
                    <CloseIcon fontSize="medium" sx={{ color: theme => theme.palette.primary.main, strokeWidth: 3 }} />
                </StyledIconButton>
            )}
        </DialogTitle>
    );
};
